import { render, staticRenderFns } from "./ContactImportValidateStep.vue?vue&type=template&id=53ff973e&scoped=true"
import script from "./ContactImportValidateStep.vue?vue&type=script&lang=js"
export * from "./ContactImportValidateStep.vue?vue&type=script&lang=js"
import style0 from "./ContactImportValidateStep.vue?vue&type=style&index=0&id=53ff973e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff973e",
  null
  
)

export default component.exports